function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.842
    },
    fill: "#000000",
    d: "M 8.5,-0.5 C 10.5,-0.5 12.5,-0.5 14.5,-0.5C 18.5,1.5 21.5,4.5 23.5,8.5C 23.5,10.5 23.5,12.5 23.5,14.5C 21.5,18.5 18.5,21.5 14.5,23.5C 12.5,23.5 10.5,23.5 8.5,23.5C 4.5,21.5 1.5,18.5 -0.5,14.5C -0.5,12.5 -0.5,10.5 -0.5,8.5C 1.5,4.5 4.5,1.5 8.5,-0.5 Z M 10.5,5.5 C 12.256,6.55213 12.9227,8.21879 12.5,10.5C 19.1667,11.1667 19.1667,11.8333 12.5,12.5C 11.8333,19.1667 11.1667,19.1667 10.5,12.5C 3.83333,11.8333 3.83333,11.1667 10.5,10.5C 10.5,8.83333 10.5,7.16667 10.5,5.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIco);
export default __webpack_public_path__ + "static/media/add_ico.09977bbe8f05685d43dced052ecd4379.svg";
export { ForwardRef as ReactComponent };